/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection13FoiChanged, m11ReportSection13ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection13Foi, selectM11ReportSection13Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveGlossaryChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section13State, setAlertModalState, setStartingSection13State) => {

    let changesStates = {
        section13State: section13State
    };
    let response = await saveM11Changes(apiToken, 39, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection13Resource) {
            dispatch(m11ReportSection13ResourceChanged(response.m11ReportSection13Resource));
        }
        setStartingSection13State(JSON.parse(JSON.stringify(section13State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step039Glossary = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection13Foi = useSelector(selectM11ReportSection13Foi);
    const m11ReportSection13Resource = useSelector(selectM11ReportSection13Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section13State, setSection13State] = useState({
        "section13Status": "empty", "section13Xhtml": ""
    });
    const [startingSection13State, setStartingSection13State] = useState({
        "section13Status": "empty", "section13Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section13State, startingSection13State)),
        async saveAllChanges() {
            await saveGlossaryChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section13State, setAlertModalState, setStartingSection13State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section13Status": "empty", "section13Xhtml": "", "loaded": true
            };
            setSection13State(startingData);
            setStartingSection13State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[13]?.entry?.length) {
                let m11ReportSection013Foi = getIdFromReference(m11ReportContainerResource.section[13].entry[0]);
                if (m11ReportSection013Foi && !isNaN(m11ReportSection013Foi) &&
                    m11ReportSection013Foi !== m11ReportSection13Foi) {
                    dispatch(m11ReportSection13FoiChanged(m11ReportSection013Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection13Foi && !isNaN(m11ReportSection13Foi)) {
            loadResource(m11ReportSection13Foi, "M11ReportSection13", apiToken, dispatch);
        }
    }, [m11ReportSection13Foi]);

    useEffect(() => {
        if (m11ReportSection13Resource && Object.keys(m11ReportSection13Resource).length > 0) {
            let startingData = {
                "section13Status": "empty", "section13Xhtml": "", "loaded": true
            };
            if (m11ReportSection13Resource.section?.[0]) {
                if (m11ReportSection13Resource.section[0].text?.div &&
                    m11ReportSection13Resource.section[0].text.status !== "empty") {
                    startingData.section13Status = m11ReportSection13Resource.section[0].text.status;
                    startingData.section13Xhtml = m11ReportSection13Resource.section[0].text.div;
                }
                setSection13State(startingData);
                setStartingSection13State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection13Resource]);

    return <div>
        <h3>Complete Section 13 Glossary of Terms and Abbreviations</h3>
        {!(m11ReportSection13Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 39 (Complete Section 13 Glossary of Terms and Abbreviations) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section13State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 13 APPENDIX: GLOSSARY OF TERMS AND ABBREVIATIONS summary as needed.</h4>
                    <TextDivEntry elementName="section13Xhtml"
                        startingValue={section13State.section13Xhtml}
                        setResourceState={setSection13State} />
                </>}
            </>
        }
    </div >
});

const M11Step039GlossaryHelperText = <div>
    <h3>Complete Section 13 Glossary of Terms and Abbreviations</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 13 APPENDIX: GLOSSARY OF TERMS AND ABBREVIATIONS.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Define abbreviations and other terms used in the protocol. A tabular presentation is common and may serve as the definition at first use.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step039GlossaryValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 39, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 39 (Complete Section 13 Glossary of Terms and Abbreviations) {validationCheckState.step39numberOfChecks} issues checked. {validationCheckState.step39numberPassed} passed. {validationCheckState.step39numberFailed} failed.</h4>
        <p>Section 13 heading is 'APPENDIX: GLOSSARY OF TERMS AND ABBREVIATIONS': {validationCheckState.resultCheckSection13Heading}</p>
        <p>Section 13 APPENDIX: GLOSSARY OF TERMS AND ABBREVIATIONS has content: {validationCheckState.resultCheckSection13Content}</p>
    </div>}  </div>
}

export default M11Step039Glossary;
export { M11Step039GlossaryHelperText, M11Step039GlossaryValidationCheck };